var map = {
	"./footer.de-CH.json": 1067,
	"./footer.de-DE.json": 1068,
	"./footer.en-CA.json": 1069,
	"./footer.en-GB.json": 1070,
	"./footer.en-IN.json": 1071,
	"./footer.en-ME.json": 1072,
	"./footer.en-US.json": 1073,
	"./footer.es-EM.json": 1074,
	"./footer.es-ES.json": 1075,
	"./footer.fr-BE.json": 1076,
	"./footer.fr-CA.json": 1077,
	"./footer.fr-CH.json": 1078,
	"./footer.nl-BE.json": 1079,
	"./footer.nl-NL.json": 1080,
	"./footer.pl-PL.json": 1081,
	"./footer.pt-BR.json": 1082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1066;